/**
 * Created by Pawel Grzyb 01.04.2018
 *
 * Widget template.
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.css']
})
export class WidgetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
